import { Component, ElementRef } from '@angular/core';
import { BaseDesignerComponent } from "../../base/base-designer-component";

@Component({
    selector: 'sx-separator-designer',
    templateUrl: './separator.designer.component.html'
})

export class SxSeparatorDesigner extends BaseDesignerComponent {
    constructor(container: ElementRef) {
        super(container, "SxSeparator");
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/text-editors/separator.designer.component.ts